import { render, staticRenderFns } from "./ss-contact-us.vue?vue&type=template&id=ee918c46&"
import script from "./ss-contact-us.vue?vue&type=script&lang=js&"
export * from "./ss-contact-us.vue?vue&type=script&lang=js&"
import style0 from "./ss-contact-us.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports